module.exports = __webpack_public_path__ + "img/project-3.86460c44.png";